export default __webpack_public_path__ + "static/working-inkitchen-3eefe74dc0e33ff4368f7a6a051c1529.png";